import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Portfolio2026 from "./components/Portfolio2026/Portfolio2026.jsx";

// Trimmed down to only what currently exists in src/ after the folder swap.
// Homepage, Aboutpage, Projects, Navbar, Footer, CustomCursor,
// ScrollToAnchor, Sample, the CaseStudy* pages, Home2026, and App.css are
// NOT imported here because they aren't on disk right now — importing a
// missing file is exactly what was throwing the "Module not found" errors.
// Once you recover those files (git / Time Machine / VS Code Timeline),
// swap this back for the fuller App.js further up this conversation and
// just re-add the two Portfolio2026 lines to it.
function App() {
  return (
    <Routes>
      <Route path="/" element={<Portfolio2026 />} />
      <Route path="/v2" element={<Portfolio2026 />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
